import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { StoragePrefix } from "@core/constant";
import { AuthService } from "@core/services/auth";
import { StorageService } from "src/app/utils";

export const AffiliationGuard: CanActivateFn = (route: any, state: any) => {
  const router = inject(Router);
  const _storage = inject(StorageService);

  const isAffiliated = _storage.get(StoragePrefix.PERSONAL_INFO)?.isAffiliated;

  if (isAffiliated === null) {
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};